import { useGetList } from "ra-core";

import type { Sponsoring } from "../types";
import type { SponsoringFilter } from "./dashboardFilters";

/**
 * Count the sponsorings matching a filter without loading them: the backend
 * returns the total, we only ask for a single record.
 */
export const useSponsoringCount = (filter: SponsoringFilter) => {
  const { total, isPending, error } = useGetList<Sponsoring>("sponsorings", {
    filter,
    pagination: { page: 1, perPage: 1 },
    sort: { field: "id", order: "ASC" },
  });
  return { count: total ?? 0, isPending, error };
};
